<script>
import EnterNumber from  '../components/EnterNumber.svelte';
import OtherNumbers from '../components/OtherNumbers.svelte';

</script>
<div class = "flex justify-center h-screen">
    <div class = "m-10">
        <h1>Number Time</h1>
        <p>Enter any number of your choice, and learn all about it! <a href = "/about">Created by Corman.</a></p>
        <br />
        <EnterNumber />
        <OtherNumbers showParagraph = {true} />
    </div>
</div>